import Vue from 'vue'
import VueRouter from 'vue-router'

//Vue中使用router插件
Vue.use(VueRouter)

//路由配置，配置路由路径与组件的对应关系
const routes = [
    {
        path: '/',
        component: () =>
            import ('../components/Index.vue')
    },
    {
        path: '/index',
        name: 'Index',
        component: () =>
            import ('../components/Index.vue')
    },
    {
        path: '/payment/antom-cashier',
        name: 'AntomCashier',
        component: () =>
            import ('../components/AntomCashier.vue')
    },
    {
        path: '/payment/antom-cashier-result',
        name: 'AntomCashierResult',
        component: () =>
            import ('../components/AntomCashierResult.vue')
    },
    {
        path: '/index/detail',
        name: 'indexDetail',
        meta: {
            requireAuth: true

        },
        component: () =>
            import ('../components/IndexDetail.vue')
    }, {
        path: '/dealer',
        name: 'Dealer',
        component: () =>
            import ('../components/Dealer.vue')
    }, {
        path: '/dealer/detail',
        name: 'dealerDetail',
        meta: {
            requireAuth: true

        },
        component: () =>
            import ('../components/DealerDetail.vue')
    }, {
        path: '/help',
        name: 'Help',
        component: () =>
            import ('../components/Help.vue')
    }, {
        path: '/help/category/:id',
        name: 'HelpCategory',
        component: () =>
            import ('../components/HelpCategory.vue')
    }, {
        path: '/help/detail/:id',
        name: 'HelpDetail',
        component: () =>
            import ('../components/HelpDetail.vue')
    }, {
        path: '/wallet',
        name: 'Wallet',
        meta: {
            requireAuth: true
        },
        component: () =>
            import ('../components/Wallet.vue')
    }, {
        path: '/subscription',
        name: 'Subscription',
        meta: {
            requireAuth: true

        },
        component: () =>
            import ('../components/Subscription.vue')
    }, {
        path: '/coupon-hall',
        name: 'CouponHall',
        component: () =>
            import ('../components/CouponHall.vue')
    }, {
        path: '/coupon-center',
        name: 'CouponCenter',
        component: () =>
            import ('../components/CouponReceive.vue')
    }, {
        path: '/user',
        name: 'UserIndex',
        meta: {
            requireAuth: true

        },
        component: () =>
            import ('../components/UserIndex.vue')
    }, {
        path: '/user/promotion',
        name: 'Promotion',
        meta: {
            requireAuth: true

        },
        component: () =>
            import ('../components/Promotion.vue')
    }, {
        path: '/user/order',
        name: 'Order',
        meta: {
            requireAuth: true

        },
        component: () =>
            import ('../components/Order.vue')
    }, {
        path: '/user/coupons',
        name: 'MyCoupons',
        meta: {
            requireAuth: true
        },
        component: () =>
            import ('../components/MyCoupons.vue')
    }, {
        path: '/user/coupon-receive',
        redirect: '/coupon-center'
    }, {
        path: '/content/:id',
        name: 'Content',
        component: () =>
            import ('../components/Content.vue')
    }, {
        path: '/login',
        name: 'Login',
        component: () =>
            import ('../components/LoginPage.vue')
    }
]

//新建路由实例
const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
})

// 统一吞掉由守卫重定向、导航取消、重复跳转导致的未捕获 Promise 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject)
    }
    return originalPush.call(this, location).catch(err => {
        if (
            err && (
                err.name === 'NavigationDuplicated' ||
                err.name === 'NavigationCancelled' ||
                err.name === 'NavigationRedirected' ||
                err.name === 'NavigationAborted'
            )
        ) {
            return err
        }
        throw err
    })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, location, onResolve, onReject)
    }
    return originalReplace.call(this, location).catch(err => {
        if (
            err && (
                err.name === 'NavigationDuplicated' ||
                err.name === 'NavigationCancelled' ||
                err.name === 'NavigationRedirected' ||
                err.name === 'NavigationAborted'
            )
        ) {
            return err
        }
        throw err
    })
}

//导出路由实例，在main.js中导入使用
export default router
